import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Index/index.vue'),
    meta: { title: '首页' },
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('@/views/Login/index.vue'),
    meta: { title: '登录' },
  },
  {
    path: '/UserInfo',
    name: 'UserInfo',
    component: () => import('@/views/UserInfo/index.vue'),
    meta: { title: '个人信息' },
  },
  {
    path: '/ChangePassword',
    name: 'ChangePassword',
    component: () => import('@/views/UserInfo/changePassword.vue'),
    meta: { title: '修改密码' },
  },
  {
    path: '/Account',
    name: 'Account',
    component: () => import('@/views/Account/index.vue'),
    meta: { title: '账号管理' },
  },
  {
    path: '/IntelligentCollection',
    name: 'IntelligentCollection',
    component: () => import('@/views/IntelligentCollection/index.vue'),
    meta: { keepAlive: true, title: '智能采集' },
  },
  {
    path: '/IntelligentCollection/addEdit',
    name: 'IntelligentCollectionAddEdit',
    component: () => import('@/views/IntelligentCollection/addEdit.vue'),
    meta: { title: '智能采集-新增编辑' },
  },
  {
    path: '/CustomerList',
    name: 'CustomerList',
    component: () => import('@/views/CustomerList/index.vue'),
    meta: { keepAlive: true, title: '采集列表' },
  },
  {
    path: '/CustomerList/addInteraction',
    name: 'CustomerListAddInteraction',
    component: () => import('@/views/CustomerList/addInteraction.vue'),
    meta: { title: '新增互动' },
  },
  {
    path: '/CustomerList/Search',
    name: 'CustomerListSearch',
    component: () => import('@/views/CustomerList/search.vue'),
    meta: { title: '客户搜索' },
  },
  {
    path: '/CustomerList/Details',
    name: 'CustomerListDetails',
    component: () => import('@/views/CustomerList/details.vue'),
    meta: { title: '客户详情' },
  },
  {
    path: '/Tactics',
    name: 'Tactics',
    component: () => import('@/views/Tactics/index.vue'),
    meta: { title: '互动文案管理' },
  },
  {
    path: '/Tactics/AddEdit',
    name: 'TacticsAddEdit',
    component: () => import('@/views/Tactics/addEdit.vue'),
    meta: { title: '话题组新增编辑' },
  },
  {
    path: '/Tactics/WordingList',
    name: 'TacticsWordingList',
    component: () => import('@/views/Tactics/wordingList.vue'),
    meta: { title: '话术库' },
  },
  {
    path: '/Tactics/WordingList/AddEdit',
    name: 'TacticsWordingListAddEdit',
    component: () => import('@/views/Tactics/wordingAddEdit.vue'),
    meta: { title: '话术新增编辑' },
  },
  {
    path: '/Tactics/WordingList/AIWordingAddEdit',
    name: 'AIWordingAddEdit',
    component: () => import('@/views/Tactics/AIWordingAddEdit.vue'),
    meta: { title: 'AI话术' },
  },
  {
    path: '/InteractionRecord',
    name: 'InteractionRecord',
    component: () => import('@/views/InteractionRecord/index.vue'),
    meta: { title: '互动记录' },
  },
  {
    path: '/InteractionRecord/Search',
    name: 'InteractionRecordSearch',
    component: () => import('@/views/InteractionRecord/search.vue'),
    meta: { title: '互动记录搜索' },
  },
  {
    path: '/MonitorCompetitors',
    name: 'MonitorCompetitors',
    component: () => import('@/views/MonitorCompetitors/index.vue'),
    meta: { title: '客户触达' },
  },

  {
    path: '/MonitorCompetitors/AddEdit',
    name: 'MonitorCompetitorsAddEdit',
    component: () => import('@/views/MonitorCompetitors/addEdit.vue'),
    meta: { title: '客户触达新增编辑' },
  },
  {
    path: '/PeerVideoTraceRetentio',
    name: 'PeerVideoTraceRetention',
    component: () => import('@/views/PeerVideoTraceRetention/index.vue'),
    meta: { title: '视频留痕', keepAlive: true },
  },
  {
    path: '/PeerVideoTraceRetentio/AddEdit',
    name: 'PeerVideoTraceRetentionAddEdit',
    component: () => import('@/views/PeerVideoTraceRetention/addEdit.vue'),
    meta: { title: '视频留痕新增编辑', keepAlive: true },
  },
  {
    path: '/MonitorCompetitors/AllPhone',
    name: 'MonitorCompetitorsAllPhone',
    component: () => import('@/views/MonitorCompetitors/allPhone.vue'),
    meta: { title: '电话号码列表' },
  },
  {
    path: '/MapGetCustomer',
    name: 'MapGetCustomer',
    component: () => import('@/views/MapGetCustomer/index.vue'),
    meta: { title: '地图获客' },
  },
  {
    path: '/IndustryGetCustomer',
    name: 'IndustryGetCustomer',
    component: () => import('@/views/IndustryGetCustomer/index.vue'),
    meta: { title: '企业获客' },
  },
  {
    path: '/Service',
    name: 'Service',
    component: () => import('@/views/Service/index.vue'),
    meta: { title: '服务中心' },
  },
  {
    path: '/Evaluate',
    name: 'Evaluate',
    component: () => import('@/views/Service/evaluate.vue'),
    meta: { title: '服务评价' },
  },
  {
    path: '/Success',
    name: 'Success',
    component: () => import('@/views/Service/success.vue'),
    meta: { title: '成功' },
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

// ✅ 强制生效，解决 hash 模式不更新标题
router.afterEach((to) => {
  setTimeout(() => {
    console.log('set title', to.meta.title);
    document.title = to.meta.title || '系统';
  }, 0);
});

export default router;
